import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormTextField } from '@/components/Form/FormTextField/FormTextField';
import { useDcrFields } from '@/features/DataChangeRequest/_constants/useDcrFields';
import { DcrFormController } from '@/features/DataChangeRequest/DcrFormController/DcrFormController';
import { FormSection } from '@/features/DataChangeRequest/DcrModal/FormSection/FormSection';

import type { ProfessionalSectionValuesIn } from '../../../_schemas/HcpSchemas/ProfessionalSection.validation';

export const HcpIdsSection = () => {
	const { t } = useTranslation();
	const { hcpFields } = useDcrFields();
	const {
		control,
		formState: { dirtyFields }
	} = useFormContext<ProfessionalSectionValuesIn>();
	const section = 'ids';

	return (
		<FormSection title={t('IDs')} id={section}>
			<DcrFormController
				name='nhidCda_V'
				section={section}
				control={control}
				render={({ field, fieldState }) => (
					<FormTextField
						id='nhidCda_V'
						label={hcpFields.nhidCda_V.label}
						name={field.name}
						defaultValue={(field.value ?? '') as string}
						indicateError={fieldState.error ? true : false}
						isDirty={!!dirtyFields.nhidCda_V}
						onChange={field.onChange}
					/>
				)}
			/>

			{/* Note: nhid_2 hidden pre-launch — not yet supported by Network API */}
			{/* <DcrFormController
				name='nhid2_V'
				section={section}
				control={control}
				render={({ field, fieldState }) => (
					<FormTextField
						id='nhid2_V'
						label={hcpFields.nhid2_V.label}
						name={field.name}
						defaultValue={(field.value ?? '') as string}
						indicateError={fieldState.error ? true : false}
						isDirty={!!dirtyFields.nhid2_V}
						onChange={field.onChange}
					/>
				)}
			/> */}
		</FormSection>
	);
};
